class ComplexPassword {
  constructor($log) {
    this.require = 'ngModel'
    this.restrict = 'A'
    this.scope = {}
    this.$log = $log
      // etc. for the usual config options
  }

  // optional compile function
  compile(tElement) {
  }

  // optional link function
  link(scope, element, attrs, ngModelController) {
    var t = this
    ngModelController.$validators.complexPassword = function(value) {
      return t.isComplex(value)
    }
  }

  isComplex(value) {
    return value != undefined &&
           value.length > 5
  }
}

ComplexPassword.$inject = ['$log']

export default ComplexPassword
